import React, { useState } from "react";
import axios from "axios"; // For API requests
import { Input, Button, message } from "antd"; // Importing Ant Design components
import "antd/dist/reset.css"; // Importing Ant Design CSS (reset.css if using V5)

const { TextArea } = Input;

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const [question, setQuestion] = useState("");

  // Toggle function to show/hide the answer
  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  // FAQ Data
  const faqs = [
    {
      question: "How do I book a bus ticket online?",
      answer: "To book a bus ticket online, simply search for your route, select your preferred bus, choose the number of seats, and proceed to payment. After payment, you will receive a booking confirmation via email or SMS.",
    },
    {
      question: "Can I cancel or modify my booking?",
      answer: "Yes, you can cancel or modify your booking by logging into your account and navigating to the 'My Bookings' section. Please note that cancellation charges may apply.",
    },
    {
      question: "What payment methods are accepted?",
      answer: "We accept various payment methods, including credit/debit cards, net banking, UPI, and digital wallets like PayPal, Google Pay, and Paytm.",
    },
    {
      question: "How will I receive my ticket?",
      answer: "Once your booking is confirmed, you will receive your ticket via email and SMS. You can also download it from the 'My Bookings' section in your account.",
    },
    {
      question: "What should I do if I miss my bus?",
      answer: "If you miss your bus, please contact our customer support immediately. Refund policies for missed buses vary depending on the operator and fare type.",
    },
  ];

  // Function to handle question submission
  const handleQuestionSubmit = async (e) => {
    e.preventDefault();
    if (question.trim() === "") {
      message.error("Please enter a question before submitting.");
      return;
    }

    try {
      // Save the question to the database (Replace with your API endpoint)
      await axios.post("/api/questions", { question });

      // Show success message
      message.success("Your question has been submitted successfully!");

      // Clear the input field
      setQuestion("");
    } catch (error) {
      // Handle error
      message.error("There was an error submitting your question. Please try again.");
    }
  };

  return (
    <section className="w-full px-4 py-8 md:py-16 bg-gray-100">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8">
          Frequently Asked Questions
        </h2>
        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-lg shadow-md p-4 cursor-pointer"
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex justify-between items-center">
                <h3 className="text-lg font-medium text-gray-800">
                  {faq.question}
                </h3>
                <span
                  className={`${
                    activeIndex === index ? "transform rotate-180" : ""
                  } transition-transform duration-300 text-xl`}
                >
                  &#9660;
                </span>
              </div>
              {activeIndex === index && (
                <p className="mt-2 text-gray-600">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>

        {/* Ask Question Section */}
        <div className="mt-8 bg-white rounded-lg shadow-md p-6">
          <h3 className="text-xl font-semibold mb-4">Have a question? Ask us!</h3>
          <form onSubmit={handleQuestionSubmit}>
            <TextArea
              rows={4}
              value={question}
              onChange={(e) => setQuestion(e.target.value)}
              placeholder="Type your question here..."
              className="mb-4"
            />
            <Button type="primary" htmlType="submit">
              Submit Question
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
